<template>
    <div>

        <config-main-title>
            Status de Rastreabilidade de Amostra
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Status
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum Status identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Status'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <small class="text-muted ml-3" v-if="dado.st_acao">{{ dado.st_acao }}</small>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div class="d-flex" v-else>
                            <div v-if="dado.st_color">
                                <span class="badge" :class="'badge-' + dado.st_color">
                                    {{ dado.in_regra_ordem }}
                                    <i class="fas fa-palette"></i>
                                </span>
                            </div>

                            <template v-if="true">
                                <button type="button" class="btn btn-sm btn-outline-secondary ml-3" @click="acessos(dado)">
                                    <i class="fas fa-user-lock mr-2"></i>
                                    {{ dado.acessos_count }}
                                </button>
                            </template>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_amostra_rastro_status ) ? '' : 'Novo' }}
                            Status
                            <span v-if="item && item.id_amostra_rastro_status" class="badge badge-secondary ml-2">
                                #{{ item.id_amostra_rastro_status }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    label="Nome do Status"
                                    :validate="validate"
                                    required
                                    v-model="item.st_amostra_rastro_status" />
                            </div>
                        
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Código Externo"
                                    :validate="validate"
                                    v-model="item.st_id_externo" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    label="Ação Especial"
                                    type="select"
                                    :validate="validate"
                                    :optionsList="[
                                        { id: 'P', search: 'Amostra Pendente' },
                                        { id: 'R', search: 'Amostra Recebida' },
                                        { id: 'N', search: 'Repetição Nova Amostra' },
                                        { id: 'U', search: 'Renumeração de Amostra' },
                                        { id: 'V', search: 'Retirada do Malote' },
                                        { id: 'F', search: 'Malote Fechado' },
                                    ]"
                                    optionsData="id"
                                    v-model="item.st_acao" />
                            </div>

                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Cor"
                                    type="select"
                                    :validate="validate"
                                    :optionsList="[
                                        { id: 'primary', search: 'Azul' },
                                        { id: 'success', search: 'Verde' },
                                        { id: 'danger', search: 'Vermelho' },
                                        { id: 'dark', search: 'Preto' },
                                        { id: 'secondary', search: 'Cinza' },
                                        { id: 'warning', search: 'Amarelo' },
                                        { id: 'info', search: 'Ciano' },
                                        { id: 'light', search: 'Branco' },
                                    ]"
                                    optionsData="id"
                                    v-model="item.st_color">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                <span class="badge" :class="'badge-' + item.st_color">
                                                    &nbsp;
                                                </span>
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <az-sub-title title="Anatomia Patológica" class="mt-3" />
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Informar Prazo de Descarte"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_info_prazo" />
                            </div>
                        </div>

                        <div class="form-row" v-if="item.fl_info_prazo">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    type="number"
                                    label="Tempo"
                                    :validate="validate"
                                    v-model="item.in_tempo_prazo" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    type="select"
                                    label="Em"
                                    :optionsList="[
                                        { id: 'days', search: 'dia(s)' },
                                        { id: 'weeks', search: 'semana(s)' },
                                        { id: 'months', search: 'mes(es)' },
                                        { id: 'years', search: 'ano(s)' },
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="item.st_unidade_tempo" />
                            </div>
                        </div>

                        <button class="btn btn-outline-primary mt-2" type="button" title="Formulário" @click="editar_formulario(item)">
                            <i class="fa-solid fa-table-list"></i>

                            <span class="badge badge-primary ml-1" v-if="item.js_formulario && item.js_formulario.length">
                                {{ item.js_formulario.length }}
                            </span>
                        </button>

                        <formulario 
                            ref="forms"
                            mode="ocultado"
                            :compact="true"
                            v-model="edicao_item.js_formulario" 
                            v-if="edicao_item" 
                            :saved="false" 
                            :config="true" />
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="amostraRastroStatus" :id="item.id_amostra_rastro_status" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_amostra_rastro_status ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import EdicaoAcessos from '../shared/EdicaoAcessos.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Formulario from '../../modulos/consultorio/Formulario.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            outros_acessos: [],
            is_reembolso: false, 
            edicao_item: null, 
        }
    },

    props: ['teste'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        EdicaoAcessos, 
        AzSubTitle,
        Formulario,
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        tem_acesso: function () { 
            return this.$route.meta.model == 'atendimento';
        },

    },

    methods: { 
        editar_formulario(item) { 
            if ( !item.js_formulario ) { 
                item.js_formulario = [];
            }

            this.edicao_item = item;

            this.$nextTick(() => { 
                this.$refs.forms.editarFormulario();
            });
        },

        remover_status(idx) { 
            this.item.js_configs.status.splice(idx, 1);
            this.$forceUpdate();
        },

        incluir_status(item) { 
            if ( !item.js_configs.status ) { 
                item.js_configs.status = [];
            }

            item.js_configs.status.push({ 
                nome: "", 
            });

            this.$forceUpdate();
        },

        acessos(item) { 
          this.$refs.acessos.abrir(
              'App\\azure\\amostraRastroStatus', 
              item.id_amostra_rastro_status
            );
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_amostra_rastro_status: null, 
                st_amostra_rastro_status: "", 
                st_color: "primary",
                fl_ativo: true, 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'amostra_rastro_status',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;

            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'amostra_rastro_status',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'amostra_rastro_status',
                dados: item,
            });

        },
    },

    mounted () { 
        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros"},
            { name: "Status de Rastreabilidade de Amostra"},
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        let id_perm = 999;

        if ( id_perm ) { 
            this.$util.valid_permissao(this, id_perm, this.load);
        } else { 
            this.load();
        }
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>